/*
 * @Author: 武汉-许晓霞 1985722833@qq.com
 * @Date: 2024-01-08 10:14:11
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 16:22:21
 * @FilePath: \mobile-portal\src\store\modules\app.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import auth from '../../utils';
import { requestToken, updateToken, getdDailyWorkNum,getdDailyWorkNumDone } from '../../global/getToken';

const app = {
  state: {
    requestStatus: '',
  },
  mutations: {
    SET_REQUEST_STATUS: (state, requestStatus) => {
      state.requestStatus = requestStatus;
    },
  },

  actions: {
    // 获取token
    RequestToken({ commit }, formdata) {
      commit('SET_REQUEST_STATUS', 'requestToken');
      return new Promise((resolve, reject) => {
        requestToken(formdata).then(response => {
          if (response) {
            commit('SET_REQUEST_STATUS', '');
            resolve(response);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    UpdateToken({ commit }, refreshToken) {
      commit('SET_REQUEST_STATUS', 'requestToken');
      return new Promise((resolve, reject) => {
        updateToken(refreshToken).then(response => {
          if (response) {
            commit('SET_REQUEST_STATUS', '');
            resolve(response);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    /**
     * @FunctionName: 获取 当前登录人的 待办 已办 申请 抄送数量
     * @Author: mhyu
     * @param {String} employeeObjId
     * @return {*}
     * @Date: 2023-07-18 16:04:07
     * @Description:
     */
    getdDailyWorkNum({ commit },param) {
      let employeeId = '';
      let account = {};
      const accountData = auth.getStorageByKey('PAI-account');
      if (accountData) {
        account = JSON.parse(accountData);
        employeeId = account.UserId;
      }
      return new Promise((resolve, reject) => {
        if (employeeId) {
          getdDailyWorkNum(param).then((res) => {
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
        } else {
          reject('');
        }
      });
    },
    //获取已办数量
    getdDailyWorkNumDone({ commit },param) {
      let employeeId = '';
      let account = {};
      const accountData = auth.getStorageByKey('PAI-account');
      if (accountData) {
        account = JSON.parse(accountData);
        employeeId = account.UserId;
      }
      return new Promise((resolve, reject) => {
        if (employeeId) {
          getdDailyWorkNumDone(param).then((res) => {
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
        } else {
          reject('');
        }
      });
    },
  },
};


export default app;
